"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VALID_VERSIONED_EXTENSIONS = exports.VALID_3D_EXTENSIONS = void 0;
exports.isValid3DFileType = isValid3DFileType;
const file_utils_1 = require("./file-utils");
exports.VALID_3D_EXTENSIONS = [
    '.3ds',
    '.asm',
    '.catpart',
    '.catproduct',
    '.glb',
    '.iam',
    '.iges',
    '.igs',
    '.ipt',
    '.obj',
    '.par',
    '.prt',
    '.sldasm',
    '.sldprt',
    '.stl',
    '.step',
    '.stp',
    '.x_b',
    '.x_t',
    '.jt',
];
exports.VALID_VERSIONED_EXTENSIONS = new Set(['.prt', '.asm']);
function isValid3DFileType(filename) {
    const name = filename.toLowerCase();
    const extension = (0, file_utils_1.getFileExtension)(name);
    if ((0, file_utils_1.isVersionedExtension)(extension)) {
        return exports.VALID_VERSIONED_EXTENSIONS.has(`.${(0, file_utils_1.getExtensionName)(extension)}`);
    }
    return exports.VALID_3D_EXTENSIONS.includes(extension);
}
//# sourceMappingURL=is-valid-3d-file-type.js.map